<template>
  <a class="brand" href="/" aria-label="Kiwi Labs home">
    <img
      src="https://kiwilabs.studio/kiwi_labs_logo.png"
      alt="Kiwi Labs logo"
      class="brand-logo"
      width="32"
      height="32"
      loading="eager"
    />
    <span class="brand-name">
      <span class="brand-kiwi">Kiwi</span>
      <span class="brand-labs">Labs</span>
    </span>
  </a>
</template>

<script lang="ts" setup></script>
